/**
 * Minimal RFC 5545 RRULE shape: must start with `RRULE:` or `FREQ=`.
 * Full RRULE parsing happens in the domain layer; this guards the boundary.
 */
export const RRULE_REGEX = /^(RRULE:|FREQ=)/;
/**
 * Local-time ISO datetime without offset: `YYYY-MM-DDTHH:mm:ss`.
 * Used for `dtstartLocal`, `occurrenceKey`, and EXDATE entries — values that
 * intentionally carry no timezone information (resolved against the series
 * `tzid` at expansion time).
 */
export const LOCAL_ISO_REGEX = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;
//# sourceMappingURL=constants.js.map